export enum SettingsMessages {
  settingsTitle = "settings.settingsTitle",
  parameters = "settings.parameters",
  timeForUndueStopOptionDescription = "settings.timeForUndueStopOptionDescription",
  timeForUndueStopOptionHelper = "settings.timeForUndueStopOptionHelper",
  functionalities = "settings.functionalities",
  enablePumpTimelineOptionDescription = "settings.enablePumpTimelineOptionDescription",
  enablePumpTimelineOptionHelper = "settings.enablePumpTimelineOptionHelper",
  enableWaterPostDischargeOptionDescription = "settings.enableWaterPostDischargeOptionDescription",
  enableWaterPostDischargeOptionHelper = "settings.enableWaterPostDischargeOptionHelper",
  blockDate = "settings.blockDate",
  blockDateHelper = "settings.blockDateHelper",
  minutes = "settings.minutes",
  defaultConstructionRadiusOptionDescription = "settings.defaultConstructionRadiusOptionDescription",
  meters = "settings.meters",
  autoTravelMinStopMinutes = "settings.autoTravelMinStopMinutes",
  timeForImproperDischargeOptionDescription = "settings.timeForImproperDischargeOptionDescription",
  timeForImproperDischargeOptionHelper = "settings.timeForImproperDischargeOptionHelper",
  seconds = "settings.seconds"
}

export type TranslationSettingsMessages = {
  [key in SettingsMessages]: string;
}
